import { useState, useEffect } from 'react'
import contentImagesData from '@/data/content-images.json'

interface ContentImage {
  id: string
  section_name: string
  image_url: string
  alt_text: string | null
  display_order: number
  is_active: boolean
}

export const useContentImages = (sectionName: string) => {
  const [images, setImages] = useState<ContentImage[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    fetchImages()
  }, [sectionName])

  const fetchImages = () => {
    try {
      const filteredImages = (contentImagesData as ContentImage[])
        .filter(img => img.section_name === sectionName && img.is_active)
        .sort((a, b) => (a.display_order || 0) - (b.display_order || 0))
      
      setImages(filteredImages)
    } catch (error) {
      console.error(`Error fetching images for ${sectionName}:`, error)
      setError('Failed to fetch images')
    } finally {
      setLoading(false)
    }
  }

  return { images, loading, error, refetch: fetchImages }
}
